// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MenuItem_wrapper__wQAUB","text":"MenuItem_text__1em2Q","active":"MenuItem_active__XP8hQ","inverted":"MenuItem_inverted__3G4PN"};